import { z } from 'zod';
export const projectApiRoutes = {
    create: {
        method: 'POST',
        path: '/organization/:organizationId/project',
        input: z
            .object({
            name: z.string(),
            ownerId: z.string().optional(),
            watcherIds: z.array(z.string()).optional(),
            description: z.string().optional(),
            defaultTaskRecipientId: z.string().nullable().optional(),
            defaultTaskDueDate: z.string().datetime({ offset: true }).optional(),
            defaultTaskEditOption: z.boolean().optional(),
            defaultTaskAutoAccept: z.boolean().optional(),
            defaultTaskDueDateDaysAfterSend: z.number().optional(),
            recipientInstructions: z.string().optional(),
        })
            .strict(),
        output: {},
    },
    read: {
        method: 'GET',
        path: '/organization/:organizationId/project/:id',
        output: {},
    },
    update: {
        method: 'POST',
        path: '/organization/:organizationId/project/:id',
        input: z
            .object({
            name: z.string().optional(),
            ownerId: z.string().optional(),
            description: z.string().nullable().optional(),
            defaultTaskRecipientId: z.string().nullable().optional(),
            defaultTaskDueDate: z.string().datetime({ offset: true }).nullable().optional(),
            defaultTaskEditOption: z.boolean().optional(),
            defaultTaskAutoAccept: z.boolean().optional(),
            defaultTaskHideResponseAfterSubmission: z.boolean().optional(),
            defaultTaskDueDateDaysAfterSend: z.number().nullable().optional(),
            recipientInstructions: z.string().optional(),
        })
            .strict(),
        output: {},
    },
    list: {
        method: 'GET',
        path: '/organization/:organizationId/projects',
        q: z.object({
            // filtering
            name: z.string().optional(),
            members: z.array(z.string()).optional(),
            status: z.string().optional(),
            // sorting
            sort: z.string().default('name').optional(),
            order: z.string().default('asc').optional(),
            // the cursor will change depending on the current sort applied. if
            // sorting by name, the cursor could be the last name in the list. if
            // sorting by recent activity, it would be the last activity date.
            cursor: z.string().optional(),
        }),
        output: {},
    },
    trashed: {
        method: 'GET',
        path: '/organization/:organizationId/projects/trashed',
        output: {},
    },
    emptyTrash: {
        method: 'DELETE',
        path: '/organization/:organizationId/projects/trashed',
        output: z.boolean(),
    },
    trash: {
        method: 'DELETE',
        path: '/organization/:organizationId/project/:id/trash',
        output: {},
    },
    untrash: {
        method: 'POST',
        path: '/organization/:organizationId/project/:id/untrash',
        output: {},
    },
    archive: {
        method: 'POST',
        path: '/organization/:organizationId/project/:id/archive',
        output: {},
    },
    unarchive: {
        method: 'POST',
        path: '/organization/:organizationId/project/:id/unarchive',
        output: {},
    },
    close: {
        method: 'POST',
        path: '/organization/:organizationId/project/:id/close',
        output: {},
    },
    reopen: {
        method: 'POST',
        path: '/organization/:organizationId/project/:id/reopen',
        output: {},
    },
    delete: {
        method: 'DELETE',
        path: '/organization/:organizationId/project/:id',
        output: {},
    },
    setWatchers: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/watchers',
        input: z.object({
            watcherIds: z.array(z.string()),
        }),
        output: {},
    },
    sendReminder: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/send-reminder',
        input: z.object({
            recipientEmail: z.string(),
        }),
        output: z.boolean(),
    },
    recipientCancelTasks: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/cancel-recipient-tasks',
        input: z.object({
            recipientEmail: z.string(),
        }),
        output: z.boolean(),
    },
    activity: {
        method: 'GET',
        path: '/organization/:organizationId/project/:projectId/activity',
        output: {},
        q: z
            .object({
            createdAfter: z.string().optional(),
            between: z.tuple([z.string(), z.string()]).optional(),
            before: z.string().optional(),
            eventTypes: z
                .array(z.union([z.literal('projects'), z.literal('tasks')]))
                .default(['projects', 'tasks'])
                .optional(),
            userIds: z.array(z.string()).optional(),
            orgRecipientIds: z.array(z.string()).optional(),
        })
            .optional(),
    },
    views: {
        method: 'GET',
        path: '/organization/:organizationId/project/:projectId/views',
        output: {},
    },
    generateRecipientMagicLink: {
        method: 'GET',
        path: '/organization/:organizationId/project/:projectId/recipient/:recipientEmail/magic-link',
        output: {},
    },
};
//# sourceMappingURL=project-api-routes.js.map